import {sx} from './sx'
import {TableCell} from "@mui/material";
import {FC, ReactNode} from "react";
import {SxProps} from "@mui/system";

interface IProps {
    align?: 'center' | 'inherit' | 'justify' | 'left' | 'right',
    component?: any,
    sx?: SxProps,
    size?: 'small' | 'medium',
    children?: ReactNode,
    rowSpan?:number | string,
    colSpan?:number | string,
    className?:string

}

const ThCustom: FC<IProps> = ({
                                  children,
                                  component = 'th',
                                  align = 'left',
                                  sx: sxProps = {},
                                  size='small',
                                  rowSpan,
                                  colSpan,
                                  className,
                              }) => {
    return (
        <TableCell
            scope="row"
            sx={{...sx, ...sxProps}}
            size={size}
            rowSpan={rowSpan as number}
            component={component}
            colSpan={colSpan as number}
            align={align}
            className={className}
        >
            {children && children}
        </TableCell>
    );
};

export default ThCustom;